import React, { useCallback, useEffect, useState } from 'react';
import { meetingService } from '../../services/meetingService';
import { FirstStepSignupConfig } from '../../types/workshopFirstStepSignup';
import { firstStepSignupCollapsedSummary, firstStepSignupShouldShow } from '../../utils/workshopFirstStepSignup';
import WorkshopCollapsibleCard from './WorkshopCollapsibleCard';
import WorkshopFirstStepSignup from './WorkshopFirstStepSignup';

interface WorkshopFirstStepSignupCardProps {
  meetingCode: string;
  canFacilitate?: boolean;
  defaultOpen?: boolean;
  nested?: boolean;
}

const WorkshopFirstStepSignupCard: React.FC<WorkshopFirstStepSignupCardProps> = ({
  meetingCode,
  canFacilitate = false,
  defaultOpen = false,
  nested = false,
}) => {
  const [config, setConfig] = useState<FirstStepSignupConfig | null>(null);
  const [loading, setLoading] = useState(true);

  const loadSummary = useCallback(async () => {
    try {
      const data = await meetingService.getFirstStepSignup(meetingCode);
      setConfig(data);
    } catch {
      setConfig(null);
    } finally {
      setLoading(false);
    }
  }, [meetingCode]);

  useEffect(() => {
    setLoading(true);
    void loadSummary();
  }, [loadSummary]);

  const subtitle = firstStepSignupCollapsedSummary(config, loading);

  if (!loading && !firstStepSignupShouldShow(config)) {
    return null;
  }

  return (
    <WorkshopCollapsibleCard
      id="first-step-signup"
      title="First Step presentation sign-up"
      subtitle={subtitle}
      defaultOpen={defaultOpen}
      nested={nested}
    >
      <WorkshopFirstStepSignup
        meetingCode={meetingCode}
        canFacilitate={canFacilitate}
        onConfigChange={setConfig}
      />
    </WorkshopCollapsibleCard>
  );
};

export default WorkshopFirstStepSignupCard;
